import React from "react";
import { motion } from "framer-motion";
import { useMenuContentAnimation } from "../utils/useMenuContentAnimationHook";

type MenuDescriptionProps = {
  title: string;
  copy: string;
  image: string;
  imageAltText: string;
  isOpen?: boolean;
};

const MenuItemDescription: React.FC<MenuDescriptionProps> = ({
  title,
  copy,
  image,
  imageAltText,
  isOpen,
}) => {
  const animateClassName = "navContentAnimation";
  const { ref, controls } = useMenuContentAnimation(isOpen);

  return (
    <motion.div
      className="w-1/4 flex-col items-start self-stretch"
      ref={ref}
      animate={controls}
    >
      <img src={image} alt={imageAltText} className="w-[240px] h-[152px]" />
      <p className="body--text-extra-large pt-6">{title}</p>
      <motion.p
        className={`body--text-small w-[240px] pt-2 ${animateClassName}`}
        animate={controls}
      >
        {copy}
      </motion.p>
    </motion.div>
  );
};

export default MenuItemDescription;
